export const LOCAL_STORAGE_UI_SCHEME_PREFERENCE_KEY = "uiSchemePreference"
export const LOCAL_STORAGE_WELCOME_TOKEN_KEY = "welcomeToken"
